export const RECEIVE_CAMPAIGNS = 'RECEIVE_CAMPAIGNS';
export const RECEIVE_CURRENT_STORE = 'RECEIVE_CURRENT_STORE';
